import * as Ariakit from '@ariakit/react';

import { Icon } from '../Icon';
import { cn } from '../utils';

export interface SimpleDialogProps extends Ariakit.DialogProps {
  title?: string;
}

export function SimpleDialog({ title, children, className, open = true, ...rest }: SimpleDialogProps) {
  return (
    <Ariakit.Dialog
      open={open}
      // backdrop={<div className="bg-[rgba(0,0,0,0.1)] backdrop-blur-sm" />}
      backdrop={false}
      className={cn(
        'relative z-50 m-auto flex h-fit w-fit min-w-96 flex-col gap-4 rounded bg-white p-6 shadow-card',
        className
      )}
      render={props => (
        <div
          className={cn(
            'fixed inset-0 z-50 overflow-auto bg-[rgba(0,0,0,0.1)] px-4 py-2 backdrop-blur-sm',
            !open && 'hidden'
          )}
        >
          <div className="flex h-full w-full items-center justify-center">
            <div {...props} />
          </div>
        </div>
      )}
      {...rest}
    >
      {title && <Ariakit.DialogHeading className="text-xl font-medium">{title}</Ariakit.DialogHeading>}
      {children}
      <Ariakit.DialogDismiss
        className="absolute right-2 top-2 inline-flex items-center justify-center gap-1 rounded text-grey-500 hover:text-black focus-visible:text-black"
        render={
          <button>
            <Icon icon="ic:close" />
          </button>
        }
      />
    </Ariakit.Dialog>
  );
}

export const SimpleDialogDismiss = Ariakit.DialogDismiss;
